export const MERIDIAN_CHAT_APP_ORIGIN = "meridianchat://app";

export function buildNativeAppUrl(path: string, query?: Record<string, string | null | undefined>) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const url = new URL(`${MERIDIAN_CHAT_APP_ORIGIN}${normalizedPath}`);

  Object.entries(query ?? {}).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

export function buildNativeLoginUrl(magicToken: string, inviteToken?: string | null) {
  return buildNativeAppUrl("/login", {
    magic_token: magicToken,
    invite_token: inviteToken ?? undefined,
  });
}
